import React from 'react';
import {
    Row,
    Col,
    Divider,
    Input,
    Typography,
    Table,
    Tag,
    Button,
    Statistic,
    Skeleton,
    Result,
    Space,
    Form,
    DatePicker,
    Select
} from 'antd';
import {
    SearchOutlined
} from '@ant-design/icons';
import { useQuery } from '@tanstack/react-query';
import dayjs from 'dayjs';
import CreateButton from '../../components/CreateButton';
import { convertPaymentType, formatPhone } from '../../utils/customFunctions';
import { paymentTypes, transactionStatus } from '../../utils/masterData';
import ChangeOrderStatus from './components/ChangeOrderStatus';
import { useNavigate, useLocation } from 'react-router-dom';
// import AddCashDoc from './components/AddCashDoc';

// const orderDateTypes = [
//     { key: 'all', value: 'all', label: 'ทั้งหมด' },
//     { key: 'orderDate', value: 'order_date', label: 'วันที่ขาย' },
//     { key: 'deliveryDate', value: 'delivery_date', label: 'วันที่ส่งของ' },
//     { key: 'billingDate', value: 'billing_date', label: 'วันที่วางบิล' }
// ];

const columns = [
    {
        title: 'เลขที่คำสั่งซื้อ',
        dataIndex: 'doc_no',
        key: 'doc_no',
        render: (text, record) =>
            <Button
                type='text'
                href={`/admin/orders/${record._id}`}
                style={{
                    width: "100%",
                    background: 'none',
                    textAlign: 'left'
                }}>
                {text}
            </Button>
    },
    {
        title: 'วันที่',
        dataIndex: 'order_date',
        key: 'order_date',
        render: (text, record) =>
            <Button
                type='text'
                href={`/admin/orders/${record._id}`}
                style={{
                    width: "100%",
                    background: 'none',
                    textAlign: 'left'
                }}>
                {dayjs(text).format('DD-MM-YYYY')}
            </Button>
    },
    {
        title: 'วันที่ส่งของ',
        dataIndex: 'shipment_date',
        key: 'shipment_date',
        render: (text, record) =>
            <Button
                type='text'
                href={`/admin/orders/${record._id}`}
                style={{
                    width: "100%",
                    background: 'none',
                    textAlign: 'left'
                }}>
                {dayjs(text).format('DD-MM-YYYY')}
            </Button>
    },
    {
        title: 'วันที่วางบิล',
        dataIndex: 'billing_date',
        key: 'billing_date',
        render: (text, record) =>
            <Button
                type='text'
                href={`/admin/orders/${record._id}`}
                style={{
                    width: "100%",
                    background: 'none',
                    textAlign: 'left'
                }}>
                {dayjs(text).format('DD-MM-YYYY')}
            </Button>
    },
    {
        title: 'ประเภทการขาย',
        dataIndex: 'payment_type',
        key: 'payment_type',
        render: (text, record) =>
            <Button
                type='text'
                href={`/admin/orders/${record._id}`}
                style={{
                    width: "100%",
                    background: 'none',
                    textAlign: 'left'
                }}>
                {convertPaymentType(text)}
            </Button>,
        // filters: paymentTypes.map(f => ({ text: f.label, value: f.value })),
        // onFilter: (value, record) => record.payment_type.indexOf(value) === 0,
    },
    {
        title: 'ลูกหนี้',
        dataIndex: 'customer',
        key: 'customer',
        render: (text, record) =>
            <Button
                type='text'
                href={`/admin/orders/${record._id}`}
                style={{
                    width: "100%",
                    background: 'none',
                    textAlign: 'left'
                }}>
                {text.fname}
            </Button>
    },
    {
        title: 'ราคาสุทธิ',
        dataIndex: 'grand_total',
        key: 'grand_total',
        render: (text, record) =>
            <Button
                type='text'
                href={`/admin/orders/${record._id}`}
                style={{
                    width: "100%",
                    background: 'none',
                    textAlign: 'left'
                }}>
                <Statistic value={text} precision={2} valueStyle={{ fontSize: 14, textAlign: 'right' }} />
            </Button>
    },

    {
        title: 'เบอร์โทรศัพท์',
        dataIndex: 'customer',
        key: 'customer',
        render: (text, record) =>
            <Button
                type='text'
                href={`/admin/orders/${record._id}`}
                style={{
                    width: "100%",
                    background: 'none',
                    textAlign: 'left'
                }}>
                {formatPhone(text.phone)}{record.customer.phone_2 && ` ; ${formatPhone(record.customer.phone_2)}`}
            </Button>
    },
    {
        title: 'สถานะ',
        dataIndex: 'transaction_status',
        key: 'transaction_status',
        width: '10%',
        // filters: transactionStatus.map(f => ({ text: f.label, value: f.value })),
        // onFilter: (value, record) => record?.transaction_status.indexOf(value) === 0,
        render: (text, record) => {
            switch (text) {
                case 'COMPLETED': return <Tag color="success">สำเร็จ</Tag>
                case 'CANCLED': return <Tag color="error">ยกเลิก</Tag>
                default: return (
                    <Space>
                        <Tag color="processing">อยู่ระหว่างดำเนินงาน</Tag>
                        <ChangeOrderStatus order={record} />
                    </Space>
                );
            }
        }
    },
]
function List() {

    const [form] = Form.useForm();
    const redirect = useNavigate();
    const location = useLocation();
    const page = new URLSearchParams(location.search).get('page');
    const page_size = new URLSearchParams(location.search).get('page_size');

    const { isError, isLoading, data, error } = useQuery({
        queryKey: [`/api/transaction/getOrders?page=${page}&page_size=${page_size}`],
    })

    const totalOrderQuery = useQuery({
        queryKey: [`/api/transaction/getTotalOrders`],
    })


    if (isLoading || totalOrderQuery.isLoading) {
        return <Skeleton active />
    }

    if (isError || totalOrderQuery.isError) {
        return <Result status="error" title={error.message || totalOrderQuery.error.message} />
    };

    const onSearch = e => {
        // redirect(`/admin/orderItems`)
        form
            .validateFields()
            .then(values => {
                // console.log(values);
                let searchText = `/admin/searchOrder?&`;
                if (values.info) searchText += `search_info=${values.info}&`;
                if (values.payment_type) searchText += `payment_type=${values.payment_type}&`;
                if (values.transaction_status) searchText += `transaction_status=${values.transaction_status}&`;
                if (values.date) searchText += `start_date=${dayjs(values.date[0]).toISOString()}&end_date=${dayjs(values.date[1]).toISOString()}&`;
                redirect(searchText);
            })
            .catch(err => {
                console.log(err)
            })
    }
    const onPageChange = (pg, pz) => {

        redirect(`/admin/orders?page=${pg}&page_size=${pz}`);

    };

    // console.log('page = ', page);
    // console.log('page_size = ', page_size);
    // console.log('totalOrderQuery = ', totalOrderQuery.data);
    // console.log(data);
    return (
        <div style={{
            background: '#fff',
        }}>
            <Row >
                <Col xs={24}>
                    <Row justify='space-between'>
                        <Col>
                            <Typography.Title level={3} style={{ padding: '0px', margin: '0px' }}>
                                รายการขายสินค้า
                            </Typography.Title>
                        </Col>
                        <Col>
                            <CreateButton linkTo='/admin/orders/create' />
                        </Col>
                    </Row>
                </Col>
                <Divider />
                <Col xs={24} >
                    <Row justify='space-between' gutter={[0, 16]}>
                        <Col xs={24}>
                            <Form
                                form={form}
                                name="searchOrder"
                                layout="vertical"
                            >
                                <Row gutter={[8, 0]}>
                                    <Col xs={24} sm={12} md={8}>
                                        <Form.Item label="" name="date" >
                                            <DatePicker.RangePicker
                                                placeholder={["วันเริ่มต้น", "วันสิ้นสุด"]}
                                                style={{ width: '100%' }} />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} sm={12} md={8}>
                                        <Form.Item
                                            label=""
                                            name="payment_type"
                                        >
                                            <Select
                                                placeholder="เลือกประเภทการขาย"
                                                showSearch
                                                optionFilterProp="children"
                                                allowClear
                                            >
                                                {paymentTypes.map(payment => <Select.Option key={payment.value} value={payment.value}>
                                                    {payment.label}
                                                </Select.Option>)}
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} sm={12} md={8}>
                                        <Form.Item
                                            label=""
                                            name="transaction_status"
                                        >
                                            <Select
                                                placeholder="เลือกสถานะ"
                                                showSearch
                                                optionFilterProp="children"
                                                allowClear
                                            >
                                                {transactionStatus.map(transaction => <Select.Option key={transaction.value} value={transaction.value}>
                                                    {transaction.label}
                                                </Select.Option>)}
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24}>
                                        <Row gutter={[8, 0]}>
                                            <Col xs={24} sm={12} >
                                                <Form.Item
                                                    label=""
                                                    name="info"
                                                >
                                                    <Input placeholder="ค้นหา เลขที่คำสั่งซื้อ ลูกหนี้ หมายเลขโทรศัพท์" />
                                                </Form.Item>
                                            </Col>
                                            <Col >
                                                <Button
                                                    type='primary'
                                                    icon={<SearchOutlined />}
                                                    onClick={onSearch}
                                                    style={{ width: '100%' }}
                                                >ค้นหา</Button>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </Form>
                        </Col>
                        <Col xs={24}>
                            <Table
                                rowKey={(record) => record._id}
                                columns={columns}
                                dataSource={data}
                                scroll={{
                                    x: 1200,
                                }}
                                pagination={{
                                    current: parseInt(page),
                                    pageSize: parseInt(page_size),
                                    total: totalOrderQuery.data,
                                    onChange: onPageChange,
                                    showSizeChanger: true
                                }}
                            />
                        </Col>
                    </Row>
                </Col>
            </Row>
        </div>
    )
}

export default List